module.exports = __webpack_public_path__ + "img/nus-recent-works.d674daa3.png";